import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { HcoService } from '../../hco/hco.service';
import { HCPHCO } from "../../../../models/lookups/hcpHco.model";
import { DisplayModes } from "../../../../models/enums";

// HCP lookup → linked HCOs: read-only list of every HCO the HCP is linked to, in any area, with the viewer's own bricks
// marked and listed first. No filters or paging; links are changed in Edit HCOs.
@Component({
  selector: 'crm-view-hcp-hcos',
  templateUrl: './view-hcp-hcos.component.html',
  styleUrls: ['./view-hcp-hcos.component.css']
})
export class ViewHcpHcosComponent implements OnInit {
  @Input() hcpId: number;
  @Output() closeModalEvent = new EventEmitter<boolean>();

  links: HCPHCO[] = [];
  displayMode: DisplayModes = DisplayModes.Loading;

  constructor(private hcoService: HcoService) {
  }

  ngOnInit() {
    this.hcoService.getHcpLinksForView(this.hcpId).subscribe(response => {
      this.links = (response as HCPHCO[]) || [];
      this.displayMode = DisplayModes.Success;
    }, () => {
      this.displayMode = DisplayModes.Error;
    });
  }

  /** False for a viewer without an area (no current job, e.g. an admin): no "your area" labels then. */
  get viewerHasArea() {
    return this.links.some(x => x.inUserArea != null);
  }

  get insideCount() {
    return this.links.filter(x => x.inUserArea).length;
  }

  back() {
    this.closeModalEvent.emit(false);
  }
}
